/**
 * Workflow Type Definitions
 */

export enum WorkflowId {
  SystemUsersWorkflow = 1,
  HQMarriagesWorkflow = 2,
  CountyMarriagesWorkflow = 3,
  HQDivorcesWorkflow = 4,
  CountyDivorcesWorkflow = 5,
}

export enum WorkflowModule {
  SystemUsers = 12,
  HQMarriages = 13,
  CountyMarriages = 14,
  HQDivorces = 15,
  CountyDivorces = 16,
}

export interface ModuleWorkflow {
  id: number;
  name: string;
}

export interface WorkflowStage {
  id: number;
  workflowId: number;
  name: string;
  description?: string;
  stageOrder: number;
  roleId: number;
  roleName?: string;
  paymentRequired?: boolean;
  useSignature: boolean;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface Workflow {
  id: number;
  moduleId: number;
  module?: string;
  name: string;
  description?: string;
  isActive: boolean;
  stages?: WorkflowStage[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateWorkflowDto {
  moduleId: number;
  name: string;
  description?: string;
  isActive: boolean;
}

export interface UpdateWorkflowDto {
  id: number;
  moduleId?: number;
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface CreateWorkflowStageDto {
  name: string;
  description?: string;
  stageOrder: number;
  roleId: number;
  useSignature: boolean;
  isActive: boolean;
}

export interface UpdateWorkflowStageDto {
  id: number;
  roleId: number;
  name: string;
  description?: string;
  stageOrder: number;
  useSignature: boolean;
  paymentRequired: boolean;
  isActive: boolean;
}

export interface ApproveWorkflowActionDto {
  workflowId: number;
  recordId: number;
  entityName: string;
  comments?: string;
}

export interface QueryWorkflowActionDto {
  workflowId: number;
  recordId: number;
  entityName: string;
  workflowStageId: number | null;
  query: string;
}

export interface RejectWorkflowActionDto {
  workflowId: number;
  recordId: number;
  entityName: string;
  comments?: string;
  reason?: string;
}

export interface WorkflowActionResponse {
  // New backend response shape
  success?: boolean;
  message?: string;
  nextStageId?: number;
  nextStageName?: string;
  isCompleted?: boolean;

  // Legacy response shape retained for backward compatibility
  id?: number;
  workflowId?: number;
  recordId?: number;
  stageId?: number;
  actionType?: string;
  comments?: string;
  createdAt?: string;
  createdBy?: number;
}

export interface CurrentStageRoleResponse {
  stageId: number;
  stageOrder: number;
  roleId: number;
  roleName?: string;
  stageName?: string;
}

export interface RequeryRemark {
  id: number;
  remark: string;
  createdAt: string;
}

export interface AppliedWorkflowAction {
  id: number;
  workflowStageId?: number;
  roleName?: string;
  stageName?: string;
  action?: string;
  comments?: string;
  actionByName?: string;
  actionDate?: string;
}
